import { Navigate } from "react-router-dom";
import AdminLayout from "../Layout/AdminLayout/AdminLayout";
// ==========Auth Routes==========
import Login from "../Pages/Auth/Login/Login";
import ForgotPassword from "../Pages/Auth/ForgotPassword/ForgotPassword";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import UserManagement from "../Pages/Admin/UserManagement/UserManagement";
import InterpreterDetails from "../Pages/Admin/UserManagement/InterpreterDetails/InterpreterDetails";
import ContentManagement from "../Pages/Admin/ContentManagement/ContentManagement";
import ReportManagement from "../Pages/Admin/ReportManagement/ReportManagement";
import Notifications from "../Pages/Admin/Notification/Notification";
import UserViewDetails from "../Pages/Admin/UserManagement/UserViewDetails/UserViewDetails";
import ReportViewDetails from "../Pages/Admin/ReportManagement/ReportViewDetails";
import IncompleteservicesDetails from "../Pages/Admin/IncompleteServices/IncompleteServicesDetails";
import IncompleteServices from "../Pages/Admin/IncompleteServices/IncompleteServices";
import NewLanguageRequest from "../Pages/Admin/LanguageManagement/NewLanguageRequest";
import ReferralManagement from "../Pages/Admin/ReferralManagement/ReferralManagement";
import InterpreterSessionFullDetails from "../Pages/Admin/UserManagement/InterpreterDetails/InterpreterLegalDocumentTranslator/InterpreterSessionFullDetails";
import UserSessionFullDetails from "../Pages/Admin/UserManagement/UserViewDetails/UserLegalDocumentTranslator/UserSessionFullDetails";
import JobReportViewDetails from "../Pages/Admin/ReportManagement/JobReportViewDetails";
import SessionManagement from "../Pages/Admin/SessionManagement/SessionManagement";

// ==========Admin Routes==========

const routes = [
  {
    path: "/",
    component: <Navigate to="/login" component={<Login />} />,
    exact: true,
  },
  {
    path: "/login",
    component: <Login />,
    exact: true,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
    exact: true,
  },
  {
    path: "/admin/*",
    component: <AdminLayout />,
    exact: true,
  },
];
export const adminLayoutRoute = [
  {
    path: "/dashboard",
    component: <Dashboard />,
    exact: true,
    sidebar: true,
  },
  {
    path: "/user-management",
    component: <UserManagement />,
    exact: true,
    sidebar: true,
  },
  {
    path: "/manage-new-language",
    component: <NewLanguageRequest />,
    exact: true,
    sidebar: true,
  },
  {
    path: "/user-details",
    component: <UserViewDetails />,
    exact: true,
    sidebar: false,
  },
   {
    path: "/session-details-details",
    component: <UserSessionFullDetails />,
    exact: true,
    sidebar: false,
  },
  {
    path: "/interpreter-details",
    component: <InterpreterDetails />,
    exact: true,
    sidebar: false,
  },
  {
    path: "/interpreter-session-details",
    component: <InterpreterSessionFullDetails />,
    exact: true,
    sidebar: false,
  },
  {
    path: "/content-management",
    component: <ContentManagement />,
    exact: true,
    sidebar: true,
  },
  {
    path: "/incomplete-services",
    component: <IncompleteServices />,
    exact: true,
    sidebar: true,
  },
  {
    path: "/incomplete-services-details",
    component: <IncompleteservicesDetails />,
    exact: true,
    sidebar: false,
  },
  {
    path: "/referral-management",
    component: <ReferralManagement />,
    exact: true,
    sidebar: true,
  },
  
  {
    path: "/reported-users",
    component: <ReportManagement />,
    exact: true,
    sidebar: true,
  },
  {
    path: "/reported-details",
    component: <ReportViewDetails />,
    exact: true,
    sidebar: false,
  },
   {
    path: "/job-reported-details",
    component: <JobReportViewDetails />,
    exact: true,
    sidebar: false,
  },
  {
    path: "/session-management",
    component: <SessionManagement />,
    exact: true,
    sidebar: true,
  },
  
  {
    path: "/notifications",
    component: <Notifications />,
    exact: true,
    sidebar: true,
  },
];
export default routes;
